export const config = {
  sdkURL: import.meta.env.PUBLIC_SID_SDK_URL || "https://jump.slashid.local",
  baseURL: import.meta.env.PUBLIC_SID_API_URL || "https://api.slashid.local",
  environment: import.meta.env.PUBLIC_SID_ENVIRONMENT,
  sentryDSN: import.meta.env.PUBLIC_SID_SENTRY_DSN,
  sentryEnabled: import.meta.env.PUBLIC_SID_ENVIRONMENT !== "local",
}
